import removeEmojis from "../utils/removeEmojis";
import escapeSpecialChars from '../utils/escapeSpecialChars';

const host = document.location.host;
const stageApihost = 'https://stageapi.i-scream.co.kr/api/toolkit/';
const productionApihost = 'https://api.i-scream.co.kr/api/toolkit/';

const isLocal =
  host.includes('localhost') ||
  host.startsWith('127.') ||
  host.startsWith('10.') ||
  host.startsWith('192.168.');
const stagehost = 'stagetoolkit.i-scream.co.kr';

let apidomain;

if(isLocal){
    apidomain = stageApihost;
}else if(host == stagehost){
    apidomain = stageApihost;
}else{
    apidomain = productionApihost;
}

let abortController = null;

// 데이터 조회
export const selectToolkitModuleInfo = async (mId, division) => {
    try {
        const response = await fetch(`${apidomain}/selectToolkitModuleInfo/${mId}/${division}`);
        if (!response.ok) {
            throw new Error(`Error ${response.status}: ${response.statusText}`);
        }
        const data = await response.json();
        // console.log('data', data);
        return data;
    } catch (error) {
        console.error("조회 오류:", error);
        throw error;
    }
};

// 데이터 추가
export const insertToolkitModuleInfo = async (mId, toolkitSequence, division, moduleInfo) => {
    try {
        const formData = new FormData();
        formData.append("mId", mId); // 사용자 ID (필수)
        formData.append("toolkitSequence", toolkitSequence); // 툴킷 고유번호 (필수)
        formData.append("division", division); // 구분 (필수)
        formData.append("moduleInfo", escapeSpecialChars(removeEmojis(JSON.stringify(moduleInfo)))); // 모듈 정보 (필수, JSON)

        const response = await fetch(`${apidomain}/insertToolkitModuleInfo`, {
            method: "POST",
            body: formData, // Content-Type 자동 설정됨
        });

        if (!response.ok) {
            throw new Error(`Error ${response.status}: ${response.statusText}`);
        }
        return await response.json();
    } catch (error) {
        console.error("추가 오류:", error);
        throw error;
    }
};

// 데이터 수정
// let debounceTimeout = null; // 디바운스 타이머

// export const updateToolkitModuleInfo = (mId, moduleSequence, moduleInfo, delay = 300) => {
//     // console.log('updateToolkitModuleInfo start')
    
//     // 기존에 설정된 디바운스 타이머가 있으면 취소
//     if (debounceTimeout) {
//         clearTimeout(debounceTimeout);
//     }

//     // 300ms 후에 최종 요청 실행 (사용자가 연속 클릭하면 마지막 요청만 실행됨)
//     debounceTimeout = setTimeout(async () => {
//         try {
//             const formData = new FormData();
//             formData.append("mId", mId);
//             formData.append("moduleSequence", moduleSequence);
//             formData.append("moduleInfo", escapeSpecialChars(removeEmojis(JSON.stringify(moduleInfo))));

//             const response = await fetch(`${apidomain}/updateToolkitModuleInfo`, {
//                 method: "POST",
//                 body: formData,
//             });

//             if (!response.ok) {
//                 throw new Error(`Error ${response.status}: ${response.statusText}`);
//             }

//             console.log("서버에 최종 데이터 저장 완료", moduleInfo);
//             return await response.json();
//         } catch (error) {
//             console.error("수정 오류:", error);
//         }
//     }, delay); // delay ms 대기 후 실행 (빠르게 연속 클릭 시 마지막 요청만 실행)
// };

// moduleSequence 단위 상태 관리
const debounceMap = {};
const inFlightMap = {};
const lastSnapshotMap = {};
const pendingSaveMap = {};
const latestSnapshotMap = {}; // ⭐ 최신 snapshot 기억

export const updateToolkitModuleInfo = (
    mId,
    moduleSequence,
    moduleInfo,
    delay = 500
) => {

    if (!moduleSequence) return;

    const snapshot = JSON.stringify(moduleInfo);
    latestSnapshotMap[moduleSequence] = snapshot;

    console.log("🟡 updateToolkitInfo 호출:", moduleSequence, "delay:", delay);

    // 🔥 FLUSH
    if (delay === 0) {

        if (debounceMap[moduleSequence]) {
            clearTimeout(debounceMap[moduleSequence]);
            debounceMap[moduleSequence] = null;
        }

        if (lastSnapshotMap[moduleSequence] === snapshot) {
            return;
        }

        if (inFlightMap[moduleSequence]) {
            console.warn("⛔ 저장 중 → pending 등록:", moduleSequence);
            pendingSaveMap[moduleSequence] = true;
            return;
        }

        executeSave(mId, moduleSequence);
        return;
    }

    // 🔵 DIRTY CHECK
    if (lastSnapshotMap[moduleSequence] === snapshot) {
        console.log("🟢 변경 없음 → debounce 스킵:", moduleSequence);
        return;
    }

    if (debounceMap[moduleSequence]) {
        clearTimeout(debounceMap[moduleSequence]);
    }

    console.log("⏳ debounce 예약:", moduleSequence, delay);

    debounceMap[moduleSequence] = setTimeout(() => {

        console.log("⏰ debounce 실행:", moduleSequence);

        if (inFlightMap[moduleSequence]) {
            console.warn("⛔ 저장 중 → pending 등록:", moduleSequence);
            pendingSaveMap[moduleSequence] = true;
            return;
        }

        executeSave(mId, moduleSequence);

    }, delay);
};

async function executeSave(mId, moduleSequence) {

    inFlightMap[moduleSequence] = true;

    try {

        const currentSnapshot = latestSnapshotMap[moduleSequence];

        const formData = new FormData();
        formData.append("mId", mId);
        formData.append("moduleSequence", moduleSequence);
        formData.append("moduleInfo", currentSnapshot);

        const response = await fetch(
            `${apidomain}/updateToolkitModuleInfo`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            throw new Error(
                `Error ${response.status}: ${response.statusText}`
            );
        }

        lastSnapshotMap[moduleSequence] = currentSnapshot;

        console.log("✅ 저장 완료:", moduleSequence);

    } catch (error) {

        console.error("❌ 저장 실패:", moduleSequence, error);

    } finally {

        inFlightMap[moduleSequence] = false;

        if (pendingSaveMap[moduleSequence]) {

            console.warn("🔁 pending 재실행:", moduleSequence);

            pendingSaveMap[moduleSequence] = false;

            executeSave(mId, moduleSequence);
        }
    }
}

// 데이터 삭제
export const deleteToolkitModuleInfo = async (mId, moduleSequence) => {
    try {
        const formData = new FormData();
        formData.append("mId", mId); // 사용자 ID (필수)
        formData.append("moduleSequence", moduleSequence); // 모듈 고유번호 (필수)

        const response = await fetch(`${apidomain}/deleteToolkitModuleInfo`, {
            method: "POST",
            body: formData, // Content-Type 자동 설정됨
        });

        if (!response.ok) {
            throw new Error(`Error ${response.status}: ${response.statusText}`);
        }
        return await response.json();
    } catch (error) {
        console.error("삭제 오류:", error);
        throw error;
    }
};
